export const EVENT_CURRENCY_DEFAULT = "JPY";

export const EVENT_IMAGE_QUALITY = 0.8;

export const EVENT_FALLBACK_IMAGE_PATH = "/no-image.png";

export const EVENT_MESSAGES = {
	DUPLICATE_TALK_ID: "このトークIDは既に登録されています",
	CONFIRM_DELETE: (systemType: string) =>
		`${systemType}を削除してもよろしいでしょうか？`,
	RESERVATION_CANCEL_NOT_IMPLEMENTED: "予約キャンセル機能は実装中です",
} as const;

export const EVENT_REGISTRATION_STATUS = [
	"pending",
	"confirmed",
	"cancelled",
	"no_show",
] as const;

export const EVENT_BOOKING_SCOPE = ["member_only", "member_and_guest"] as const;

export const EVENT_GROUP_BOOKING_MODE = [
	"single",
	"primary_companion",
] as const;

export const EVENT_ATTENDANCE_SOURCE = [
	"barcode",
	"manual",
	"migration",
] as const;

export type EventRegistrationStatus =
	(typeof EVENT_REGISTRATION_STATUS)[number];
export type EventBookingScope = (typeof EVENT_BOOKING_SCOPE)[number];
export type EventGroupBookingMode = (typeof EVENT_GROUP_BOOKING_MODE)[number];
export type EventAttendanceSource = (typeof EVENT_ATTENDANCE_SOURCE)[number];
